function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6 4.174H2.904A2.006 2.006 0 0 0 .901 6.18v8.816c0 1.106.897 2.003 2.003 2.005H9.6a2.006 2.006 0 0 0 1.997-2.005V6.18c-.001-1.104-.893-2-1.997-2.005zm.515 10.821c0 .285-.23.515-.515.515H2.904a.515.515 0 0 1-.514-.515V6.18c0-.283.23-.513.514-.513H9.6c.284 0 .514.23.515.513v8.816z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.096 1H6.914c-1 0-1.81.81-1.81 1.81a.746.746 0 0 0 1.49 0 .32.32 0 0 1 .32-.32h6.182c.284 0 .514.23.514.515v8.31a.32.32 0 0 1-.32.32h-.381a.746.746 0 0 0 0 1.491h.382a1.811 1.811 0 0 0 1.808-1.81V3.006A2.006 2.006 0 0 0 13.096 1z"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "#0BBE35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.594e915c.svg";
export { ForwardRef as ReactComponent };